import React from "react";
import SweetAlert from 'react-bootstrap-sweetalert';
import ReactAutocomplete from 'react-autocomplete';

export default (props) => {

    const {
        inputProps,
        handleDescription,
        handleTool,
        handleToolSelect,
        resetNewMethodData,
        saveNewMethod,
        handleFocusMethod,
        handleMethodSelect,
        handleMethod,
        objects,
        errorMessages,
    } = props;

    let {type, show, objectIndex} = inputProps;

    if(!objects || objectIndex === undefined || objectIndex === null) return false;
    let object = Object.assign({}, objects[objectIndex]);
    if(!object) return false;

    let {
        values:{methodValue},
        description,
        toolValue,
        toolAutoCompleteData,
        createMethodErrors,
        methodAutoCompleteData,
        createMethodButtonShow,
        createMethodStatus,
    } = object;
    let title = "Новый метод";

    const inputPropsMethod = {
        onFocus: (e) => handleFocusMethod(e.target.value, objectIndex)
    }

    return (
        <SweetAlert
            style={{overflow:'unset'}}
            type={type}
            confirmBtnCssClass="alert-btn-confirm"
            cancelBtnCssClass="alert-btn-cancel"
            showCancel
            showConfirm
            show={show}
            confirmBtnText="Продолжить"
            cancelBtnText={"Отменить"}
            confirmBtnBsStyle="danger"
            cancelBtnBsStyle="default"
            title={title}
            onConfirm={() => saveNewMethod(objectIndex)}
            onCancel={() => resetNewMethodData(objectIndex)}
        >
            <div className="invoice-modal__body">
                <label className="invoice-modal__label">Заголовок</label>

                <div style={{marginBottom:'25px'}}>
                    <div className="moadl-a-wr autocomplete-wrapper" style={{position:'relative', width:'100%'}}>
                        <ReactAutocomplete
                            inputProps={{...inputPropsMethod, placeholder: "Метод съемки"}}
                            items={methodAutoCompleteData || []}
                            renderInput={(props) => <input {...props}/>}
                            shouldItemRender={(item, value) => item.title.toLowerCase().indexOf(value.toLowerCase()) > -1}
                            getItemValue={item => item.title}
                            renderItem={(item, highlighted) => 
                                <div
                                    key={item.id}
                                    style={{ backgroundColor: highlighted ? '#eee' : 'transparent'}}>
                                    {item.title}
                                </div>
                            }
                            renderMenu={(items, value) =>{
                                return <div className="autocomplete-dropdown" children={items}/>
                            }}
                            value={methodValue}
                            onChange={(e) => handleMethod(e.target.value, objectIndex)}
                            onSelect={(value, item) => handleMethodSelect(item, objectIndex)}
                        />
                    </div>

                    {
                        createMethodErrors && createMethodErrors.methodValue ?
                        <div className="input-error-text etmt10">{createMethodErrors.methodValue}</div>
                        : null
                    }
                </div>

                <label className="invoice-modal__label">Описание</label>
                <div style={{marginTop: '8px',marginBottom: '25px'}}>
                    <textarea
                        className="invoice-modal__input"
                        style={{marginTop: 0,marginBottom: 0, height:'65px'}}
                        value={description}
                        disabled={createMethodButtonShow ? false : true}
                        onChange={(e) => handleDescription(e.target.value, objectIndex)}
                        >
                    </textarea>

                    {
                        createMethodErrors && createMethodErrors.description ?
                        <div className="input-error-text etmt10">{createMethodErrors.description}</div>
                        : null
                    }
                </div>

                <label className="invoice-modal__label">Инструмент</label>
                <div style={{marginTop: '8px',marginBottom: '25px'}}>
                    <div className="moadl-a-wr autocomplete-wrapper" style={{position:'relative', width:'100%'}}>
                        <ReactAutocomplete
                            inputProps={{placeholder: "Инструмент"}}
                            items={toolAutoCompleteData || []}
                            renderInput={(props) => <input disabled={createMethodButtonShow ? false : true} {...props}/>}
                            shouldItemRender={(item, value) => item.title.toLowerCase().indexOf(value.toLowerCase()) > -1}
                            getItemValue={item => item.title}
                           // wrapperProps={{style: {position:'relative'}}}
                            renderItem={(item, highlighted) => 
                                <div
                                    key={item.id}
                                    style={{ backgroundColor: highlighted ? '#eee' : 'transparent'}}>
                                    {item.title}
                                </div>
                            }
                            renderMenu={(items, value) =>{
                                return <div className="autocomplete-dropdown" children={items}/>
                            }}
                            value={toolValue}
                            onChange={(e) => handleTool(e.target.value, objectIndex)}
                            onSelect={(value, item) => handleToolSelect(item, objectIndex)}
                        />
                    </div>
                    {
                        createMethodErrors && createMethodErrors.toolValue ?
                        <div className="input-error-text etmt10">{createMethodErrors.toolValue}</div>
                        : null
                    }
                </div>
            </div> 

        </SweetAlert>
    );
}


// WEBPACK FOOTER //
// ./src/components/MakeOrder/Modals/CreateMethod.js